
import ayoa from "../document/ayoa.png"
import {
 
  Box,
 
  Flex,
  Grid,
  
  Image,
 
  Text,
  
} from "@chakra-ui/react";
import React from "react";

import ProjectComponent from "./Project";

function Projects({ colorMode }) {
  return (
    <Box id="projects" mt="10" position="relative">
      <br />
      <br />
      <Box position={"absolute"} w="100%">
        <Image
          src="https://d1edzrgaei4psf.cloudfront.net/newHome/12.svg"
          opacity=".3"
          w="100%"
        />
      </Box>
      <Flex w="full" justifyContent={"center"} position="relative">
        <Text
          color="orange.500"
          fontSize="22px"
          letterSpacing="20px"
          fontWeight="700"
          mt="5"
        >
          PROJECTS
        </Text>
      </Flex>
      <br />
      <Grid
        w="90%"
        m="auto"
        gridTemplateColumns={{
          base: "repeat(1fr)",
          md: "repeat(2,1fr)",
          lg: "repeat(3,1fr)",
        }}
        gap="9"
        rowGap={"9"}
      >
        {arr?.map((el, i) => {
          return <ProjectComponent colorMode={colorMode} key={i} {...el} />;
        })}
      </Grid>
    </Box>
  );
}

export default Projects;

const arr = [
  {
    image: ayoa,
    title: "Ayoa Clone",
  techStack: ["HTML" , "CSS" , "Javascript" , "React" , "Chakra-UI"] ,
    desc: "Ayoa is the original mind mapping app used by millions Great for those looking to brainstorm ideas and get creative. Freehand organic mind maps. Speed mind maps. Radial maps. Capture maps.",
    link: "https://ayoa-com-five.vercel.app/",
    watch: "",
    github: "https://github.com/satyam0337/Ayoa",
    solo: "A solo Project executed in 05 days",
  },
  {
    image:
      "https://user-images.githubusercontent.com/103956874/210200519-45762ab0-b4af-490e-9ae0-c39643cfb608.png",
    title: "Purplle Clone",
    techStack:
     ["NodeJS" , "ExpressJs" , "MongoDB" , "React" , "Redux" , "Javascript" , "chakra-UI"],
    desc: "Purplle.com is an Indian beauty e-commerce platform that sells personal care products from various brands via its website and mobile app.",
    link: "https://purplle-orcin.vercel.app/",
    watch: "",
    github: "https://github.com/satyam0337/purplle",
    solo: "A Group Project of 3 members, executed in 05 days",
  },
  {
    image:
      "https://user-images.githubusercontent.com/105915649/235349069-d5f13e9b-cbd3-48e8-b027-0d0379a19d77.png",
    title: "Youtube Clone",
    techStack: ["HTML" , "CSS" , "Javascript"],
    desc: "This is a clone of famous E-Commerce Pharma web application, which provides healthcare products, labtests , health packages etc.",
    link: "https://youtube-lt8xwkksn-satyam0337.vercel.app/",
    watch: "",
    github: "https://github.com/satyam0337/Youtube-clone",
    solo: "A solo Project executed in 02 days",
  },
  {
    image:
      "https://user-images.githubusercontent.com/105915649/235349518-37149e3e-9eda-4847-8ea4-02750e68f814.png",
    title: "Tic-Tac-Toe Game",
    techStack: ["HTML" , "CSS" , "Javascript"],
    desc: "Tic-Tac-Toe is a game played on a 3x3 grid where players take turns marking a square with their symbol (X or O) in an attempt to get three of their symbols in a row before the other player.",
    link: "https://satyam-game.vercel.app/",
    watch: "",
    github: "https://github.com/satyam0337/Tic-tac-toe-game",
    solo: "A solo Project executed in 03 days",
  },
];


